



































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Header from '@/components/Header.vue'
import Banner from '@/views/reservation/molecules/Banner.vue'
import { initReservationFormViewModel } from '@/models/ReservationFormViewModel'
import { AlertModule } from '@/store/modules/alert'
import Indicator from './molecules/Indicator.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import PrivacyPolicyPage from '../privacy-policy/PrivacyPolicyPage.vue'
import ErrorMessage from './atoms/ErrorMessage.vue'
import RequiredBadge from './atoms/RequiredBadge.vue'
import ReturnTopButton from './atoms/ReturnTopButton.vue'
import ErrorBanner from './molecules/ErrorBanner.vue'
import PopupDatePicker from './molecules/PopupDatePicker.vue'
import PopupCalendar from './organisms/PopupCalendar.vue'
import {
  getClinics,
  getTokyoClinicId,
  getOsakaClinicId,
  getNagoyaClinicId
} from '@/utils/clinic-constants'
import { retrieveClinics } from '@/api/clinic'
import { formatDate } from '@/utils'
import { getDays, getYears, validateDate } from '@/utils/date-util'
import { ClinicResponse } from '@/interface/api'
import { PRIVACY_POLICY_URL, getColors, IsMens } from '@/utils/app-setting'
import Constants from '@/utils/constants'
import { isKana, validLength } from '@/utils/validate'
import { RouteName } from '@/router'
import { ReservationForm } from '@/store/modules/form'

@Component({
  name: 'Reservation',
  components: {
    Header,
    Banner,
    Indicator,
    PrivacyPolicyPage,
    ValidationProvider,
    ValidationObserver,
    ReturnTopButton,
    ErrorBanner,
    RequiredBadge,
    ErrorMessage,
    PopupCalendar,
    PopupDatePicker
  }
})
export default class Reservation extends Vue {
  // フォーム情報
  public reservationForm = initReservationFormViewModel()
  // クリニックリスト
  public clinics = getClinics()
  public clinicResponces: ClinicResponse[] = []
  // 月
  public optionMonths = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  // public hasPm = true
  // 生年月日エラー
  public birthdayError = ''
  // なまえエラー
  public nameError = ''
  // クリニック未選択エラー
  public notSelectedClinicFirstError = ''
  public notSelectedClinicSecondError = ''
  // 午前・午後未選択エラー
  public firstChoiceTimeError = ''
  public secondChoiceTimeError = ''
  public selectedFormatDate = ''
  public selectedFirstDate = ''
  public selectedSecondDate = ''
  // 初診・再診オプション
  public isFirstTreatmentRadioOption = Constants.IsFirstTreatmentRadioOption
  // 診察タイプカテゴリ
  public treatmentCategoryOption = Constants.TreatmentCategoryOption
  // プライバシーポリシーURL
  public privacyPolicyUrl = PRIVACY_POLICY_URL
  public colors = getColors()
  public formBgColor = this.colors.formBgColor
  public formFontColor = this.colors.formFontColor
  public isMens = IsMens()
  public errorMsg = false
  public osakaClinicId = getOsakaClinicId()
  public tokyoClinicId = getTokyoClinicId()
  public nagoyaClinicId = getNagoyaClinicId()

  public isErrorAlertOpen = false
  private isWarningAlertOpen = false
  private canFaceToFace = false
  private canOnlineTreatment = false
  private isFirst = true

  private get errorTime() {
    return AlertModule.errorTime
  }

  public get errorAlertMessage() {
    return AlertModule.errorAlertMessage
  }

  private get warningTime() {
    return AlertModule.warningTime
  }

  private get warningAlertMessage() {
    return AlertModule.warningAlertMessage
  }

  private get selectedFirstDateLabel() {
    return formatDate(
      this.selectedFirstDate,
      Constants.DateFormat.YYYYNEN_MMGATU_DDNICHI_YOUBI
    )
  }

  private get selectedSecondDateLabel() {
    return formatDate(
      this.selectedSecondDate,
      Constants.DateFormat.YYYYNEN_MMGATU_DDNICHI_YOUBI
    )
  }

  @Watch('errorTime')
  private async onErrorTimeChange() {
    this.isErrorAlertOpen = true
  }

  @Watch('warningTime')
  private async onWarningTimeChange() {
    this.isWarningAlertOpen = true
  }

  public $refs!: {
    form: HTMLFormElement
    contentTop: HTMLFormElement
  }

  created() {
    this.clinics = getClinics()
    // this.getClinics() medicalBusinessIdが定まらないと取得できない
    this.setReservationForm()
    this.reservationForm.treatmentCategoryName =
      this.treatmentCategoryOption.Visit.value
  }

  public get isOsaka(): boolean {
    return this.osakaClinicId === this.reservationForm.clinic.clinicId
  }

  public get isTokyo(): boolean {
    return this.tokyoClinicId === this.reservationForm.clinic.clinicId
  }

  public get isNagoya(): boolean {
    return this.nagoyaClinicId === this.reservationForm.clinic.clinicId
  }

  public get isFirstDateWednesday(): boolean {
    return new Date(this.selectedFirstDate).getDay() === 3
  }

  public get isSecondDateWednesday(): boolean {
    return new Date(this.selectedSecondDate).getDay() === 3
  }

  private setReservationForm() {
    this.reservationForm.clinic.medicalBusinessId =
      ReservationForm.clinic.medicalBusinessId
    this.reservationForm.clinic = ReservationForm.clinic
    this.reservationForm.treatmentCategoryName =
      ReservationForm.treatmentCategoryName
    this.reservationForm.desiredTreatment = ReservationForm.desiredTreatment
    this.reservationForm.isFirstTreatment = ReservationForm.isFirstTreatment
    this.reservationForm.reservationDate = ReservationForm.reservationDate
    this.setDate(ReservationForm.firstChoice.reservationDate, true)
    this.reservationForm.firstChoice.isAm = ReservationForm.firstChoice.isAm
    this.setDate(ReservationForm.secondChoice.reservationDate, false)
    this.reservationForm.secondChoice.isAm = ReservationForm.secondChoice.isAm
    this.reservationForm.firstName = ReservationForm.firstName
    this.reservationForm.lastName = ReservationForm.lastName
    this.reservationForm.birthYear = ReservationForm.birthYear
    this.reservationForm.birthMonth = ReservationForm.birthMonth
    this.reservationForm.birthDate = ReservationForm.birthDate
    this.reservationForm.phoneNumber = ReservationForm.phoneNumber
    this.reservationForm.email = ReservationForm.email
    this.reservationForm.contactTool = ReservationForm.contactTool
    this.reservationForm.comment = ReservationForm.comment
    this.reservationForm.treatmentSpotId = ReservationForm.treatmentSpotId
  }

  @Watch('reservationForm.clinic')
  private setClinicInfo() {
    if (this.isFirst) {
      this.isFirst = false
      return
    }
    // 予約日をリセットする
    this.reservationForm.firstChoice.reservationDate = new Date()
    this.reservationForm.firstChoice.isAm = null
    this.selectedFirstDate = ''
    this.reservationForm.secondChoice.reservationDate = new Date()
    this.reservationForm.secondChoice.isAm = null
    this.selectedSecondDate = ''

    // クリニックを設定
    // const selectedClinicInfo = this.clinicResponces.find(
    //   v => v.clinic.id === this.reservationForm.clinic.clinicId
    // )
    // if (selectedClinicInfo) {
    //   this.reservationForm.clinic.business_hours =
    //     selectedClinicInfo.business_hours
    // }
  }

  public async confirm() {
    const validateAll = await this.$refs.form.validate()
    const validateBD = this.validateBirthdate()
    const validateName = this.validateFirstName() || this.validateLastName()
    const validateTime = this.validateChoiceTime()

    if (!validateAll || !validateBD || !validateName || !validateTime) {
      this.errorMsg = true
      this.$refs.contentTop.scrollIntoView({ behavior: 'smooth' })
    } else {
      console.log(this.reservationForm)
      ReservationForm.setReservationForm(this.reservationForm)
      this.$router.push({ name: RouteName.RESERVATION_CONFIRM })
    }
  }

  public setDate(date: Date | null, isFirst: boolean) {
    if (!date) {
      return
    }
    if (isFirst) {
      this.reservationForm.firstChoice.reservationDate = new Date(date)
      this.reservationForm.firstChoice.isAm = null
      this.selectedFirstDate = formatDate(
        date,
        Constants.DateFormat.YYYY_MM_DD_HYPHEN
      )
    } else {
      this.reservationForm.secondChoice.reservationDate = new Date(date)
      this.reservationForm.secondChoice.isAm = null
      this.selectedSecondDate = formatDate(
        date,
        Constants.DateFormat.YYYY_MM_DD_HYPHEN
      )
    }
  }

  // 午前・午後表示
  public hasAm(date: string, isFirst: boolean): boolean {
    const day =
      this.reservationForm.clinic.nonTargetDays[new Date(date).getDay()]

    return !day || (day && day.am)
  }

  public hasPm(date: string, isFirst: boolean): boolean {
    const day =
      this.reservationForm.clinic.nonTargetDays[new Date(date).getDay()]
    return !day || (day && day.pm)
  }

  public validateChoiceTime(): boolean {
    this.firstChoiceTimeError = this.getChoiceTimeError(
      this.reservationForm.firstChoice.isAm
    )
    this.secondChoiceTimeError = this.getChoiceTimeError(
      this.reservationForm.secondChoice.isAm
    )
    return !this.firstChoiceTimeError && !this.secondChoiceTimeError
  }

  private getChoiceTimeError(isAm: boolean | null): string {
    if (isAm === null) {
      return '午前か午後かを選択してください'
    } else {
      return ''
    }
  }

  @Watch('reservationForm.clinic.clinicId')
  public setErrorFirstChoiceMsg() {
    this.notSelectedClinicFirstError = this.validateClinic()
  }

  @Watch('reservationForm.clinic.clinicId')
  public setErrorSecondChoiceMsg() {
    this.notSelectedClinicSecondError = this.validateClinic()
  }

  private validateClinic(): string {
    if (!this.reservationForm.clinic.clinicId) {
      return 'ご希望のクリニックを選択してください'
    } else {
      return ''
    }
  }

  @Watch('reservationForm.firstName')
  public validateFirstName(): boolean {
    return this.validateName(this.reservationForm.firstName)
  }

  @Watch('reservationForm.lastName')
  public validateLastName(): boolean {
    return this.validateName(this.reservationForm.lastName)
  }

  private validateName(name: string): boolean {
    let isValid = true
    let message = ''
    if (!name || !isKana(name)) {
      message = 'おなまえはカタカナで入力してください'
      isValid = false
    } else if (!validLength(name, 45)) {
      message = '45字以内で入力してください'
      isValid = false
    }
    this.nameError = isValid ? '' : message
    return isValid
  }

  public get getYears(): number[] {
    return getYears()
  }

  public get getDays(): number[] {
    return getDays(
      this.reservationForm.birthYear,
      this.reservationForm.birthMonth
    )
  }

  private validateBirthdate(): boolean {
    const isValid = validateDate(
      this.reservationForm.birthYear,
      this.reservationForm.birthMonth,
      this.reservationForm.birthDate
    )
    this.birthdayError = isValid ? '' : '正しい日付を選択してください'
    return isValid
  }

  // private async getClinics() {
  //   this.clinicResponces = await retrieveClinics(
  //     medicalBusinessIdが定まらないと取得できない
  //   )
  // }

  public async setTreatmentSpot(spotId: string, spotDatetime: Date) {
    this.reservationForm.reservationDate = spotDatetime
    this.selectedFormatDate = formatDate(
      this.reservationForm.reservationDate,
      Constants.DateFormat.YYYYNEN_MMGATU_DDNICHI_ZIHUN
    )
    this.reservationForm.treatmentSpotId = spotId
  }
}
